/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

/**
 *     Import
 *     - Components
 */
import { Button } from '../Button/Button'
import { SearchIcon } from '../../../images/icons/Search/Search'
import { DropdownArrowIcon } from '../../../images/icons/DropdownArrow/DropdownArrow'

/**
 *     Import
 *     - CSS
 */
import './styles/HeaderContainer.css'

/**
 * [render description]
 * @param  {String}      className [Class to be applied on the main header block]
 * @param  {Bool}        fullwidth [True = Block will fit 100% of the browser width]
 * @param  {String}      title     [Main title]
 * @param  {String}      image     [Image for the title]
 * @param  {String}      pretitle  [Text on top of main title]
 * @return {ReactNode}   children  [All code on the right side should be passed as children]
 */
export default class HeaderContainer extends React.Component<any, any> {

    constructor(props: any) {
        super(props)

        this.state = {
            typeSelected: this.props.selected ? this.props.selected : this.props.titles[0],
            selectorOpened: false,
            searchButtonVisible: false,
            searchText: '',
        }
    }

    changeType = (element) => {
        if (element !== this.state.typeSelected) {
            this.setState({ typeSelected: element, selectorOpened: false })
            this.props.triggerAction(element)
        }
    }

    openSelector = () => {
        this.setState({ selectorOpened: true })
    }

    clearInput = () => {
        if (this.state.searchText) {
            this.setState({ searchButtonVisible: false, searchText: '' })
            this.props.onSearch('')
        }
    }

    onSearch = ({ target: { value } }) => {
        const isNotEmpty = value !== ''
        this.setState({
            searchButtonVisible: isNotEmpty,
            searchText: value,
        })

        if (!isNotEmpty) {
            this.search()
        }
    }

    search = () => {
        if (this.props.onSearch) {
            this.props.onSearch(this.state.searchText)
        }
    }

    render() {
        return (
            <div className={`header${(this.props.fullwidth) ? ' header--full' : ''} ${this.props.className || ''}`}>
                <div className="header_inner">
                    <div className="header__title">
                        {(this.props.back) ? (
                            <div
                                className="header__title__back"
                                onClick={this.props.backAction}
                            >
                                <DropdownArrowIcon color={'#5174AE'} /><span>BACK</span>
                            </div>
                        ) : null}
                        {this.props.pretitle && <h3>{this.props.pretitle}</h3>}
                        <div>
                            {
                                (this.props.image) ?
                                    <div className="header__title__image">
                                        <img src={this.props.image} alt="Profile photo" />
                                    </div>
                                    :
                                    null
                            }
                            <h2
                                onClick={this.openSelector}
                                className={`${(this.props.titles.length > 1) ? 'pointer' : ''}
                                ${(this.props.image) ? ' imageText' : ''}`}
                            >
                                {this.state.typeSelected.charAt(0).toUpperCase() + this.state.typeSelected.slice(1)}
                                {(this.props.titles.length > 1) ?
                                    <div className="arrow">
                                        <DropdownArrowIcon />
                                    </div> :
                                    null
                                }

                            </h2>
                            {(this.props.titles.length > 1) ? (
                                <div
                                    className={`header__title__dropdown ${(!this.state.selectorOpened) ?
                                        'hidden' :
                                        ''}`
                                    }
                                >
                                    {
                                        this.props.titles.map((element, index) => (
                                            <div
                                                key={index}
                                                className={(this.state.typeSelected === element) ? 'selected' : ''}
                                                onClick={() => { this.changeType(element) }}
                                            >
                                                {element.charAt(0).toUpperCase() + element.slice(1)}
                                            </div>
                                        ))
                                    }
                                </div>
                            ) : null}
                        </div>
                    </div>
                    <div className="header__content">
                        {this.props.children}
                    </div>
                    {this.props.searchBarVisible &&
                        <div className="header__search">
                            <div className="search_icon">
                                <SearchIcon />
                            </div>
                            <div className="header__search__searching_bar">
                                <div className="input">
                                    <input
                                        placeholder="Start typing to search"
                                        type="text"
                                        value={this.state.searchText}
                                        onChange={(event) => { this.onSearch(event) }}
                                    />
                                </div>
                                <div
                                    className={`buttons ${this.state.searchButtonVisible === true ?
                                        `btn_visible` :
                                        `btn_hidden`}`}
                                >
                                    <Button onClick={this.search} className="search_button">
                                        Search
                                    </Button>
                                    <Button onClick={this.clearInput} className="search_button">
                                        Clear
                                    </Button>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/common/HeaderContainer/HeaderContainer.tsx